const { useState } = wp.element;
const { __ } = wp.i18n;

// Components
import Icon from './Icon';

const Locate = ( { panTo } ) => {
	const [ isLocating, setIsLocating ] = useState( false );
	return (
		<button
			className="btn btn--red"
			onClick={ () => {
				setIsLocating( true );
				window.navigator.geolocation.getCurrentPosition(
					position => {
						panTo( {
							lat: position.coords.latitude,
							lng: position.coords.longitude,
						} );
						setIsLocating( false );
					},
					() => null
				);
			} }
		>
			{ isLocating ? <Icon name="loading" /> : <Icon name="navigation" /> }
			{ __( 'Find nearest retailers', 'ankarsrum' ) }
		</button>
	);
};

export default Locate;
